// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4d9e13c8","703":"f74079db"}[chunkId] + ".chunk.js";
};